// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  width: 100%;
  height: 100%;
}

.header_block {
  width: 100%;
  padding: 10px 15px 0px;
  background: white;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
}
.header_block .wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.header_block .wrapper .back_icon {
  width: 20%;
  text-align: start;
  cursor: pointer;
}
.header_block .wrapper app-burger-btn {
  width: 20%;
}
.header_block .info-section {
  width: 60%;
  text-align: center;
}
.header_block .info-section .section-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.header_block .info-section .section-info .step-indicator .step-text {
  font-family: AppFontBold, sans-serif;
  font-size: 12px;
  color: #dc143c;
  text-transform: uppercase;
  background: rgba(220, 20, 60, 0.1);
  padding: 4px 12px;
  border-radius: 12px;
  border: 1px solid #dc143c;
  white-space: nowrap;
}
.header_block .info-section .section-info .name h5 {
  margin: 0;
  font-size: 16px;
}
.header_block ion-icon {
  width: 20px;
}
.header_block h5 {
  font-size: 18px;
  color: black;
  font-family: AppFontBold, sans-serif;
}

.block_item {
  width: 100%;
  height: calc(100% - 150px);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: url('background_wood.png') no-repeat center center/100% 100%;
  position: relative;
}
.block_item .left {
  width: 49.9%;
  height: 100%;
}
.block_item .left .article_info {
  left: 0px !important;
}
.block_item .right {
  width: 49.9%;
  height: 100%;
}
.block_item .right swiper-slide {
  justify-content: flex-start !important;
}
.block_item .right .slide__card {
  justify-content: flex-start !important;
}
.block_item .right .article_info {
  right: 0px !important;
  text-align: right !important;
}
.block_item .random_slide {
  position: absolute;
  bottom: 40px;
  right: 20px;
  z-index: 5;
  text-align: center;
  width: 60px;
}
.block_item .random_slide p {
  color: white;
  font-family: AppFontBold, Helvetica, sans-serif;
  font-size: 12px;
  background: transparent;
  text-transform: uppercase;
  text-align: center;
  padding: 5px;
}
.block_item .random_slide ion-icon {
  width: 45px;
  height: 45px;
}
.block_item .total_price_section {
  font-family: AppFontBold;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  text-transform: uppercase;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  padding: 8px 16px;
  border-radius: 20px;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.swiper_block {
  width: 100%;
  height: 100%;
}

.slide.swiper-slide-active .slide__card {
  height: 105%;
  opacity: 1;
  position: relative;
}
.slide.swiper-slide-active .slide__card img {
  height: 100%;
  width: auto;
}
@media (min-width: 991px) {
  .slide.swiper-slide-active .slide__card img {
    height: 110%;
    object-fit: fill;
    width: auto;
  }
}
.slide.swiper-slide-active .slide__card ion-img {
  height: 100%;
  width: 50%;
}
@media (min-width: 991px) {
  .slide.swiper-slide-active .slide__card ion-img {
    height: 110%;
    object-fit: fill;
    width: auto;
  }
}
.slide.swiper-slide-active .slide__card .article_info {
  position: absolute;
  top: -40px;
  display: block;
  text-align: left;
}
.slide.swiper-slide-active .slide__card .article_info h4 {
  color: white;
}
.slide__card {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60%;
  opacity: 0.5;
  transition: opacity 1s;
  width: 80%;
  position: relative;
}
.slide__card ion-img {
  height: 80%;
  width: 45%;
}
.slide__card img {
  height: 80%;
  width: auto;
}
.slide__card .article_info {
  position: absolute;
  top: 0px;
  display: none;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  margin: 0 auto !important;
  --swiper-pagination-left: 20px;
  --swiper-pagination-bullet-width: 2px;
  --swiper-pagination-bullet-size: 12px;
  --swiper-pagination-bullet-border-radius: 0px;
  --swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);
  --swiper-pagination-color: white;
  --swiper-pagination-bullet-vertical-gap: 0px;
}
swiper-container swiper-slide {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.right {
  --swiper-pagination-right: 20px;
  --swiper-pagination-left: 20;
  --swiper-pagination-bullet-width: 2px;
  --swiper-pagination-bullet-size: 12px;
  --swiper-pagination-bullet-border-radius: 0px;
  --swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);
  --swiper-pagination-color: white;
  --swiper-pagination-bullet-vertical-gap: 0px;
}
.right swiper-slide {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer_block {
  width: 100%;
  display: flex;
  background: var(--default-background);
  justify-content: center;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  padding: 20px 0px 0px 0px;
  z-index: 99;
}
.footer_block ion-button {
  width: 95%;
}

.tab_buttons {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0;
  z-index: 10;
}
.tab_buttons .tab_button {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  padding: 12px 32px;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
  transition: all 0.3s ease;
  flex: 1;
  min-width: 180px;
}
.tab_buttons .tab_button:first-child {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}
.tab_buttons .tab_button:last-child {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
}
.tab_buttons .tab_button.active {
  background-color: #dc143c;
  color: white;
}
.tab_buttons .tab_button:not(.active) {
  background-color: white;
  color: #333;
}
.tab_buttons .tab_button:hover {
  opacity: 0.9;
}

.know-tab-content {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 80px;
}
.know-tab-content .dotted-divider {
  position: relative;
  height: 8px;
  margin: 8px auto;
  width: 80%;
}
.know-tab-content .dotted-divider::before, .know-tab-content .dotted-divider::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-image: radial-gradient(circle, white 1px, transparent 1px);
  background-size: 5px 2px;
  background-repeat: repeat-x;
}
.know-tab-content .dotted-divider::before {
  top: 2px;
}
.know-tab-content .dotted-divider::after {
  bottom: 2px;
}
.know-tab-content .selection-section {
  transition: all 0.3s ease-in-out;
  margin-bottom: 20px;
}
.know-tab-content .selection-section:not(:first-child) {
  margin-top: 30px;
}
.know-tab-content .selection-header {
  text-align: center;
  padding: 0 20px;
}
.know-tab-content .selection-header h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
  color: white;
  text-transform: uppercase;
  margin: 0;
  line-height: 1.2;
}
.know-tab-content .scrollable-content {
  height: calc(100% - 60px);
  overflow-y: auto;
  padding: 0 20px 80px 20px;
  /* Custom scrollbar */
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #dc143c transparent;
}
.know-tab-content .scrollable-content::-webkit-scrollbar {
  width: 2px;
}
.know-tab-content .scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}
.know-tab-content .scrollable-content::-webkit-scrollbar-thumb {
  background: #dc143c;
  border-radius: 1px;
}
.know-tab-content .scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #b01030;
}
.know-tab-content .scrollable-content .pizza-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  padding-bottom: 20px;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card {
  background: white;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  height: 140px;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card.selected {
  border-color: #dc143c;
  box-shadow: 0 0 10px rgba(220, 20, 60, 0.3);
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .card-image {
  width: 80px;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .card-image img,
.know-tab-content .scrollable-content .pizza-grid .pizza-card .card-image ion-img {
  width: 80%;
  object-fit: cover;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .card-info {
  padding: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .card-info h4 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: #333;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  line-height: 1.2;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .card-info .card-description {
  font-family: AppFont, sans-serif;
  font-size: 11px;
  color: #666;
  margin: 0 0 8px 0;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  flex: 1;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .card-info .card-price {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: #333;
  margin: 0;
  font-weight: bold;
  align-self: flex-start;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .selection-indicator {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: #dc143c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.know-tab-content .scrollable-content .pizza-grid .pizza-card .selection-indicator .check-icon {
  color: white;
  font-size: 16px;
}

.plate {
  position: absolute;
  width: 0px;
  aspect-ratio: 1/1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  overflow: auto;
}
.plate ion-img {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-half-pizza/select-half-pizza.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,YAAA;AADD;;AAGA;EACC,WAAA;EACA,sBAAA;EAEA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,yDAAA;AADD;AAEC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAAF;AACE;EACC,UAAA;EACA,iBAAA;EACA,eAAA;AACH;AACE;EACC,UAAA;AACH;AAGC;EACC,UAAA;EACA,kBAAA;AADF;AAGE;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AADH;AAII;EACC,oCAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAFL;AAOI;EACC,SAAA;EACA,eAAA;AALL;AAWC;EACC,WAAA;AATF;AAWC;EACC,eAAA;EACA,YAAA;EACA,oCAAA;AATF;;AAaA;EACC,WAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,wEAAA;EACA,kBAAA;AAVD;AAYC;EACC,YAAA;EACA,YAAA;AAVF;AAWE;EACC,oBAAA;AATH;AAeC;EACC,YAAA;EACA,YAAA;AAbF;AAcE;EACC,sCAAA;AAZH;AAcE;EACC,sCAAA;AAZH;AAcE;EACC,qBAAA;EACA,4BAAA;AAZH;AAeC;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AAbF;AAcE;EACC,YAAA;EACA,+CAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAZH;AAcE;EACC,WAAA;EACA,YAAA;AAZH;AAeC;EACC,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;UAAA,0BAAA;AAbF;;AAgBA;EACC,WAAA;EACA,YAAA;AAbD;;AAkBE;EACC,YAAA;EACA,UAAA;EACA,kBAAA;AAfH;AAgBG;EACC,YAAA;EACA,WAAA;AAdJ;AC5IE;EDwJC;IAIE,YAAA;IACA,gBAAA;IACA,WAAA;EAZH;AACF;AAcG;EACC,YAAA;EACA,UAAA;AAZJ;ACvJE;EDiKC;IAIE,YAAA;IACA,gBAAA;IACA,WAAA;EAVH;AACF;AAaG;EACC,kBAAA;EAEA,UAAA;EACA,cAAA;EACA,gBAAA;AAZJ;AAaI;EACC,YAAA;AAXL;AAgBC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EASA,kBAAA;AAtBF;AAcE;EACC,WAAA;EACA,UAAA;AAZH;AAcE;EACC,WAAA;EACA,WAAA;AAZH;AAgBE;EACC,kBAAA;EAEA,QAAA;EACA,aAAA;AAfH;;AAmBA;EACC,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,8BAAA;EACA,qCAAA;EACA,qCAAA;EACA,6CAAA;EACA,6DAAA;EACA,gCAAA;EACA,4CAAA;AAhBD;AAiBC;EACC,eAAA;EACA,aAAA;EAEA,mBAAA;EACA,yBAAA;AAhBF;;AAsBA;EAKC,+BAAA;EACA,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,6CAAA;EACA,6DAAA;EACA,gCAAA;EACA,4CAAA;AAvBD;AAwBC;EACC,eAAA;EACA,aAAA;EAEA,mBAAA;EACA,yBAAA;AAvBF;;AA2BA;EACC,WAAA;EACA,aAAA;EACA,qCAAA;EAEA,uBAAA;EACA,yDAAA;EACA,yBAAA;EACA,WAAA;AAzBD;AA0BC;EACC,UAAA;AAxBF;;AA4BA;EACC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,MAAA;EACA,WAAA;AAzBD;AA2BC;EACC,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,OAAA;EACA,gBAAA;AAzBF;AA2BE;EACC,4BAAA;EACA,+BAAA;AAzBH;AA4BE;EACC,6BAAA;EACA,gCAAA;AA1BH;AA6BE;EACC,yBAAA;EACA,YAAA;AA3BH;AA8BE;EACC,uBAAA;EACA,WAAA;AA5BH;AA+BE;EACC,YAAA;AA7BH;;AAkCA;EACC,WAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AA/BD;AAiCC;EACC,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AA/BF;AAiCE;EAEC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,qEAAA;EACA,wBAAA;EACA,2BAAA;AAhCH;AAmCE;EACC,QAAA;AAjCH;AAoCE;EACC,WAAA;AAlCH;AAsCC;EACC,gCAAA;EACA,mBAAA;AApCF;AAsCE;EACC,gBAAA;AApCH;AAwCC;EACC,kBAAA;EACA,eAAA;AAtCF;AAwCE;EACC,oCAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAtCH;AA0CC;EACC,yBAAA;EACA,gBAAA;EACA,yBAAA;EAEA,qBAAA;EAkBA,YAAA;EACA,qBAAA;EACA,oCAAA;AA1DF;AAuCE;EACC,UAAA;AArCH;AAwCE;EACC,uBAAA;AAtCH;AAyCE;EACC,mBAAA;EACA,kBAAA;AAvCH;AA0CE;EACC,mBAAA;AAxCH;AA+CE;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;AA7CH;AA+CG;EACC,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AA7CJ;AA+CI;EACC,qBAAA;EACA,2CAAA;AA7CL;AAgDI;EACC,YAAA;EACA,mBAAA;AA9CL;AAiDI;EACC,2BAAA;EACA,yCAAA;AA/CL;AAkDI;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;AAhDL;AAkDK;;EAEC,UAAA;EACA,iBAAA;AAhDN;AAoDI;EACC,aAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAlDL;AAoDK;EACC,oCAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAlDN;AAqDK;EACC,gCAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,OAAA;AAnDN;AAsDK;EACC,oCAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AApDN;AAwDI;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtDL;AAwDK;EACC,YAAA;EACA,eAAA;AAtDN;;AA8DA;EACC,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,cAAA;AA3DD;AA4DC;EACC,YAAA;EACA,WAAA;AA1DF","sourcesContent":["@import '../../../theme/mixins';\n\n.main {\n\twidth: 100%;\n\theight: 100%;\n}\n.header_block {\n\twidth: 100%;\n\tpadding: 10px 15px 0px;\n\n\tbackground: white;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tbox-shadow: 0px -4px 50px 0px #0000001a;\n\t.wrapper {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\twidth: 100%;\n\t\t.back_icon {\n\t\t\twidth: 20%;\n\t\t\ttext-align: start;\n\t\t\tcursor: pointer;\n\t\t}\n\t\tapp-burger-btn {\n\t\t\twidth: 20%;\n\t\t}\n\t}\n\n\t.info-section {\n\t\twidth: 60%;\n\t\ttext-align: center;\n\n\t\t.section-info {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tgap: 8px;\n\n\t\t\t.step-indicator {\n\t\t\t\t.step-text {\n\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tcolor: #dc143c;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tbackground: rgba(220, 20, 60, 0.1);\n\t\t\t\t\tpadding: 4px 12px;\n\t\t\t\t\tborder-radius: 12px;\n\t\t\t\t\tborder: 1px solid #dc143c;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.name {\n\t\t\t\th5 {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\tion-icon {\n\t\twidth: 20px;\n\t}\n\th5 {\n\t\tfont-size: 18px;\n\t\tcolor: black;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n}\n\n.block_item {\n\twidth: 100%;\n\theight: calc(100% - 150px);\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\tbackground: url('../../../assets/losteria/background_wood.png') no-repeat center center/ 100% 100%;\n\tposition: relative;\n\n\t.left {\n\t\twidth: 49.9%;\n\t\theight: 100%;\n\t\t.article_info {\n\t\t\tleft: 0px !important;\n\t\t}\n\t\t.first {\n\t\t\t// rotate: 180deg;\n\t\t}\n\t}\n\t.right {\n\t\twidth: 49.9%;\n\t\theight: 100%;\n\t\tswiper-slide {\n\t\t\tjustify-content: flex-start !important;\n\t\t}\n\t\t.slide__card {\n\t\t\tjustify-content: flex-start !important;\n\t\t}\n\t\t.article_info {\n\t\t\tright: 0px !important;\n\t\t\ttext-align: right !important;\n\t\t}\n\t}\n\t.random_slide {\n\t\tposition: absolute;\n\t\tbottom: 40px;\n\t\tright: 20px;\n\t\tz-index: 5;\n\t\ttext-align: center;\n\t\twidth: 60px;\n\t\tp {\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFontBold, Helvetica, sans-serif;\n\t\t\tfont-size: 12px;\n\t\t\tbackground: transparent;\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\t\t\tpadding: 5px;\n\t\t}\n\t\tion-icon {\n\t\t\twidth: 45px;\n\t\t\theight: 45px;\n\t\t}\n\t}\n\t.total_price_section {\n\t\tfont-family: AppFontBold;\n\t\tposition: absolute;\n\t\tbottom: 20px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tcolor: white;\n\t\ttext-transform: uppercase;\n\t\tz-index: 10;\n\t\tbackground: rgba(0, 0, 0, 0.6);\n\t\tpadding: 8px 16px;\n\t\tborder-radius: 20px;\n\t\tbackdrop-filter: blur(5px);\n\t}\n}\n.swiper_block {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.slide {\n\t&.swiper-slide-active {\n\t\t.slide__card {\n\t\t\theight: 105%;\n\t\t\topacity: 1;\n\t\t\tposition: relative;\n\t\t\timg {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: auto;\n\t\t\t\t@include desktop {\n\t\t\t\t\theight: 110%;\n\t\t\t\t\tobject-fit: fill;\n\t\t\t\t\twidth: auto;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-img {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 50%;\n\t\t\t\t@include desktop {\n\t\t\t\t\theight: 110%;\n\t\t\t\t\tobject-fit: fill;\n\t\t\t\t\twidth: auto;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.article_info {\n\t\t\t\tposition: absolute;\n\t\t\t\t// left: 0px;\n\t\t\t\ttop: -40px;\n\t\t\t\tdisplay: block;\n\t\t\t\ttext-align: left;\n\t\t\t\th4 {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&__card {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\theight: 60%;\n\t\topacity: 0.5;\n\t\ttransition: opacity 1s;\n\t\twidth: 80%;\n\t\tion-img {\n\t\t\theight: 80%;\n\t\t\twidth: 45%;\n\t\t}\n\t\timg {\n\t\t\theight: 80%;\n\t\t\twidth: auto;\n\t\t}\n\t\tposition: relative;\n\n\t\t.article_info {\n\t\t\tposition: absolute;\n\t\t\t// left: 0px;\n\t\t\ttop: 0px;\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tmargin: 0 auto !important;\n\t--swiper-pagination-left: 20px;\n\t--swiper-pagination-bullet-width: 2px;\n\t--swiper-pagination-bullet-size: 12px;\n\t--swiper-pagination-bullet-border-radius: 0px;\n\t--swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);\n\t--swiper-pagination-color: white;\n\t--swiper-pagination-bullet-vertical-gap: 0px;\n\tswiper-slide {\n\t\tmax-width: 100%;\n\t\tdisplay: flex;\n\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t}\n}\n//  swiper-container::part(pagination) {\n//     rotate: 90deg;\n// }\n.right {\n\t// width: 100% !important;\n\t// height: 100% !important;\n\t// margin: 0 auto !important;\n\t// --swiper-pagination-left: 100%;\n\t--swiper-pagination-right: 20px;\n\t--swiper-pagination-left: 20;\n\t--swiper-pagination-bullet-width: 2px;\n\t--swiper-pagination-bullet-size: 12px;\n\t--swiper-pagination-bullet-border-radius: 0px;\n\t--swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);\n\t--swiper-pagination-color: white;\n\t--swiper-pagination-bullet-vertical-gap: 0px;\n\tswiper-slide {\n\t\tmax-width: 100%;\n\t\tdisplay: flex;\n\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t}\n}\n\n.footer_block {\n\twidth: 100%;\n\tdisplay: flex;\n\tbackground: var(--default-background);\n\n\tjustify-content: center;\n\tbox-shadow: 0px -4px 50px 0px #0000001a;\n\tpadding: 20px 0px 0px 0px;\n\tz-index: 99;\n\tion-button {\n\t\twidth: 95%;\n\t}\n}\n\n.tab_buttons {\n\tposition: absolute;\n\ttop: 20px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tdisplay: flex;\n\tgap: 0;\n\tz-index: 10;\n\n\t.tab_button {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 14px;\n\t\tpadding: 12px 32px;\n\t\tborder: none;\n\t\tcursor: pointer;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: bold;\n\t\ttransition: all 0.3s ease;\n\t\tflex: 1;\n\t\tmin-width: 180px;\n\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 25px;\n\t\t\tborder-bottom-left-radius: 25px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 25px;\n\t\t\tborder-bottom-right-radius: 25px;\n\t\t}\n\n\t\t&.active {\n\t\t\tbackground-color: #dc143c;\n\t\t\tcolor: white;\n\t\t}\n\n\t\t&:not(.active) {\n\t\t\tbackground-color: white;\n\t\t\tcolor: #333;\n\t\t}\n\n\t\t&:hover {\n\t\t\topacity: 0.9;\n\t\t}\n\t}\n}\n\n.know-tab-content {\n\twidth: 100%;\n\theight: calc(100% - 80px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 0;\n\tmargin-top: 80px;\n\n\t.dotted-divider {\n\t\tposition: relative;\n\t\theight: 8px;\n\t\tmargin: 8px auto;\n\t\twidth: 80%;\n\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\theight: 2px;\n\t\t\tbackground-image: radial-gradient(circle, white 1px, transparent 1px);\n\t\t\tbackground-size: 5px 2px;\n\t\t\tbackground-repeat: repeat-x;\n\t\t}\n\n\t\t&::before {\n\t\t\ttop: 2px;\n\t\t}\n\n\t\t&::after {\n\t\t\tbottom: 2px;\n\t\t}\n\t}\n\n\t.selection-section {\n\t\ttransition: all 0.3s ease-in-out;\n\t\tmargin-bottom: 20px;\n\n\t\t&:not(:first-child) {\n\t\t\tmargin-top: 30px;\n\t\t}\n\t}\n\n\t.selection-header {\n\t\ttext-align: center;\n\t\tpadding: 0 20px;\n\n\t\th3 {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 20px;\n\t\t\tcolor: white;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin: 0;\n\t\t\tline-height: 1.2;\n\t\t}\n\t}\n\n\t.scrollable-content {\n\t\theight: calc(100% - 60px);\n\t\toverflow-y: auto;\n\t\tpadding: 0 20px 80px 20px;\n\n\t\t/* Custom scrollbar */\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 2px;\n\t\t}\n\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground: transparent;\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground: #dc143c;\n\t\t\tborder-radius: 1px;\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb:hover {\n\t\t\tbackground: #b01030;\n\t\t}\n\n\t\t/* Firefox */\n\t\tscrollbar-width: thin;\n\t\tscrollbar-color: #dc143c transparent;\n\n\t\t.pizza-grid {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 1fr 1fr;\n\t\t\tgap: 15px;\n\t\t\tpadding-bottom: 20px;\n\n\t\t\t.pizza-card {\n\t\t\t\tbackground: white;\n\t\t\t\tposition: relative;\n\t\t\t\tcursor: pointer;\n\t\t\t\ttransition: all 0.3s ease;\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\theight: 140px;\n\n\t\t\t\t&.selected {\n\t\t\t\t\tborder-color: #dc143c;\n\t\t\t\t\tbox-shadow: 0 0 10px rgba(220, 20, 60, 0.3);\n\t\t\t\t}\n\n\t\t\t\t&.disabled {\n\t\t\t\t\topacity: 0.5;\n\t\t\t\t\tcursor: not-allowed;\n\t\t\t\t}\n\n\t\t\t\t&:hover:not(.disabled) {\n\t\t\t\t\ttransform: translateY(-2px);\n\t\t\t\t\tbox-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n\t\t\t\t}\n\n\t\t\t\t.card-image {\n\t\t\t\t\twidth: 80px;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: flex-start;\n\n\t\t\t\t\timg,\n\t\t\t\t\tion-img {\n\t\t\t\t\t\twidth: 80%;\n\t\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.card-info {\n\t\t\t\t\tpadding: 12px;\n\t\t\t\t\tflex: 1;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tjustify-content: space-between;\n\n\t\t\t\t\th4 {\n\t\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tcolor: #333;\n\t\t\t\t\t\tmargin: 0 0 4px 0;\n\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\tline-height: 1.2;\n\t\t\t\t\t}\n\n\t\t\t\t\t.card-description {\n\t\t\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\t\tcolor: #666;\n\t\t\t\t\t\tmargin: 0 0 8px 0;\n\t\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t}\n\n\t\t\t\t\t.card-price {\n\t\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tcolor: #333;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t\talign-self: flex-start;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.selection-indicator {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbottom: 8px;\n\t\t\t\t\tright: 8px;\n\t\t\t\t\twidth: 24px;\n\t\t\t\t\theight: 24px;\n\t\t\t\t\tbackground: #dc143c;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\n\t\t\t\t\t.check-icon {\n\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.plate {\n\tposition: absolute;\n\twidth: 0px;\n\taspect-ratio: 1 / 1;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tz-index: 1;\n\toverflow: auto;\n\tion-img {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
